import PushNotificationAlert from './PushNotificationAlert';

export default {
  PushNotificationAlert,
};
